import React from "react";

import { CloseIcon, SearchIcon, TrashIcon } from "@pages/casino/assets/icons";
import { Modal } from "@pages/casino/components";

import {
	CloseIconOverlay,
	DropdownContainer,
	DropdownHeader,
	DropdownItem,
	DropdownList,
	DropdownScroll,
	FilterHeader,
	InfoText,
	ItemWrapper,
	ModalItem,
	ModalItemsWrapper,
	SearchButton,
	SearchContainer,
} from "./element.js";
import useController from "./useController";

const DROPDOWN_ITEMS_LENGTH = 45;

const Dropdown = ({
	items,
	placeholder,
	onSelect,
	name,
	value,
	onClose,
	isModalDisabled,
	initialSelectedItem,
	isProvidersFilter,
}) => {
	const {
		refs: { headerRef, searchRef },
		helpers: { translate },
		state: { open, isMobile, isTablet, isSearchOpen, selectedItem, searchTerm, filteredItems },
		handlers: {
			handleSelect,
			handleClearSearchInput,
			setIsSearchOpen,
			setSearchTerm,
			handleToggle,
		},
	} = useController({
		value,
		items,
		onSelect,
		onClose,
		initialSelectedItem,
		isProvidersFilter,
	});

	return (
		<DropdownContainer
			className={name || ""}
			data-testid={`dropdown-${name}`}>
			<DropdownHeader
				open={open}
				onClick={handleToggle}>
				<p ref={headerRef}>{placeholder}</p>
			</DropdownHeader>
			{isMobile ||
			isTablet ||
			(isModalDisabled ? false : DROPDOWN_ITEMS_LENGTH < items?.length) ? (
				<Modal
					position={"top"}
					hasOverflow
					open={open}
					onClose={handleToggle}>
					<ModalItemsWrapper>
						<FilterHeader>
							{placeholder}
							{placeholder ? <span>{items?.length}</span> : null}
							<SearchButton onClick={() => setIsSearchOpen(!isSearchOpen)}>
								<SearchIcon
									width="24px"
									height="24px"
								/>
							</SearchButton>
						</FilterHeader>
						{isSearchOpen && (
							<>
								<SearchContainer
									ref={headerRef}
									noValue={searchTerm.length === 0}
									hasItem={filteredItems?.length > 0 && searchTerm.length > 0}>
									<SearchIcon
										width="24px"
										height="24px"
									/>
									<input
										ref={searchRef}
										type="text"
										placeholder="Search..."
										value={searchTerm}
										autoFocus
										onChange={(e) => setSearchTerm(e.target.value)}
									/>
									<TrashIcon
										className="search-input-trash-icon"
										onClick={handleClearSearchInput}
									/>
								</SearchContainer>
								{searchTerm?.length > 0 &&
									(filteredItems?.length === 0 ? (
										<InfoText>{translate("casino.noSearchProvider")}</InfoText>
									) : (
										<InfoText>
											{translate("casino.searchProvider", {
												provider: filteredItems?.length,
											})}
										</InfoText>
									))}
							</>
						)}
						<ItemWrapper
							isSearchOpen={isSearchOpen}
							className="item-wrapper">
							{filteredItems?.map((item) => (
								<ModalItem
									key={item.key}
									isSelected={item?.key === selectedItem?.key}
									onClick={() => handleSelect(item)}>
									{name === "sort-dropdown" ? translate(item.value) : item.value}
								</ModalItem>
							))}
							<CloseIconOverlay />
							<CloseIcon
								className="modal-close-icon"
								onClick={() => {
									handleToggle();
									setSearchTerm("");
									setIsSearchOpen(false);
								}}
							/>
						</ItemWrapper>
					</ModalItemsWrapper>
				</Modal>
			) : (
				<DropdownList open={open}>
					<DropdownScroll>
						{items?.map((item) => (
							<DropdownItem
								key={item.key}
								isSelected={item?.key === selectedItem?.key}
								onClick={() => handleSelect(item)}>
								{name === "sort-dropdown" ? translate(item.value) : item.value}
							</DropdownItem>
						))}
					</DropdownScroll>
				</DropdownList>
			)}
		</DropdownContainer>
	);
};

export default Dropdown;
